(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = this.querySelector('[data-header]');
        this.stickyType = this.getAttribute('data-sticky-type');

        if (!this.header || this.stickyType === 'none') return;

        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        var observer = new IntersectionObserver(function (entries, observer) {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        }.bind(this));
        observer.observe(this.header);
    }

    onScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);
                this.isScrolling = setTimeout(function () {
                    this.preventReveal = false;
                }.bind(this), 66);
                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.stickyType === 'always') return;
        this.header.closest('.section-header').classList.add(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky'
        );
        this.closeMenus();
    }

    reveal() {
        this.header.closest('.section-header').classList.add('shopify-section-header-sticky', 'animate');
        this.header.closest('.section-header').classList.remove('shopify-section-header-hidden');
    }

    reset() {
        this.header.closest('.section-header').classList.remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate'
        );
    }

    closeMenus() {
        document.querySelectorAll('[data-megamenu-panel]').forEach(function (panel) {
            panel.classList.remove('megamenu--active');
            panel.setAttribute('aria-hidden', 'true');
        });
    }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
